import React from "react";
import { useSelector } from "react-redux";
import { decode } from "html-entities";

export default function SelectedWebformItem(props) {
  const system = useSelector((state) => state.systemReducer);
  const webform = props.webform;

  return (
    <div className="selected-webform-item" onClick={() => props.removeSelectedWebformItem(webform)}>
      <div className="selected-news-item-image">
        <img src={`https://${system.subdomain}.companyapp.net${webform.field_featured_image}`} />
      </div>
      <div className="selected-webform-item-title">{decode(webform.title)}</div>
    </div>
  );
}
